import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredStep?: number;
}

export const ProtectedRoute = ({
  children,
  requiredStep,
}: ProtectedRouteProps) => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    // Redirect to login page but save the attempted url
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  if (requiredStep && user?.registrationStep !== undefined) {
    if (user.registrationStep < requiredStep) {
      // Redirect to the appropriate registration step
      return (
        <Navigate to="/auth/register" state={{ from: location }} replace />
      );
    }
  }

  return <>{children}</>;
};
